var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"errorModal",attrs:{"id":"errorModal","title":_vm.$t('error_modal_title'),"title-tag":"h3","centered":"","lazy":"","ok-only":"","ok-variant":"danger","ok-title":_vm.$t('close'),"header-bg-variant":"danger","header-text-variant":"light"}},[_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }